import { useTranslation } from 'react-i18next';
import { Link } from 'components/Link';
import { AccessErrorProps } from 'services/interface';
import notFound from 'images/notFound.svg';

export const AccessError = ({ link = true }: AccessErrorProps) => {
    const { t } = useTranslation();

    return (
        <div className='tw:flex tw:flex-col tw:justify-center tw:items-center tw:w-full tw:h-full tw:m-auto'>
            <img src={notFound} draggable={false} alt={t('Not found icon')} />
            <div className='tw:flex tw:flex-col tw:gap-32 tw:justify-between'>
                <div className='tw:md:w-580 tw:px-10 tw:flex tw:flex-col tw:gap-9 tw:justify-between tw:text-center'>
                    <span className='tw:text-headline'>
                        {t('Access is restricted because your IP is not approved by the organization administrators')}
                    </span>
                    {link ? (
                        <span className='tw:text-body tw:text-neutrals-800 tw:dark:text-neutrals-500'>
                            {t(
                                'Please contact your organization administrator for updating the restrictions. If you are administrator, you can login and reset the IP allowlist ',
                            )}
                            <Link to={`${process.env.GATSBY_IDAAS_URL}/reset-ip-whitelist`} isExternal>
                                {t('here')}
                            </Link>
                            .
                        </span>
                    ) : (
                        <span className='tw:text-body tw:text-neutrals-800 tw:dark:text-neutrals-500'>
                            {t('Your IP is blocked because of abuse')}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};
